class sliderPager {

	constructor(sliderId) {
	}

	getSlidePager() {

		return (
			`
			<div class="slider-pager-outer">
				<div class="slide-pager slide-pager--carousel">
					<div class="slide-pager__inner">
						
						<div class="slide-pager__half slide-pager__half--left">
							
							<span class="slide-pager__number slide-pager__number--index">1</span>

						</div>

						<div class="slide-pager__half slide-pager__half--right">
							
							<span class="slide-pager__number slide-pager__number--total">6</span>

						</div>

					</div>
				</div>
			</div>
			`
		)

	}

}
module.exports = new sliderPager;